// KeywordChip.js
const KeywordChip = ({ keyword }) => {
    return <span className="keyword-chip">{keyword}</span>;
};

export default KeywordChip;
